import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export function render({ theme }) {
  const button = document.querySelector(".c-header__button");
  const toggle = button.querySelector(".c-header__toggle");
  const title = document.querySelector(".l-hero__title>span");
  const god_btn = document.querySelector(".c-god__button");
  const god_logo = document.querySelectorAll(".c-god__logo>*");
  const wrapper = document.querySelector(".c-header__contact");
  const contact = document.querySelectorAll(".-js-contact");
  const chars = document.querySelectorAll(
    ".-js-contact.-is-front .c-header__characters"
  );

  ScrollTrigger.matchMedia({
    "(min-width: 1366px)": function () {
      gsap.set(chars, {
        translateX: "15rem",
      });

      const tl = gsap.timeline({ paused: true });
      tl.to(chars, {
        ease: "Circ.easeOut",
        stagger: 0.08,
        translateX: 0,
      }).to(contact, {
        rotateX: "+=180",
      });

      wrapper.addEventListener("mouseenter", (e) => tl.play());
      wrapper.addEventListener("mouseleave", (e) => tl.reverse());
    },

    all: function () {
      button.addEventListener("click", () => {
        theme.switchTheme();
        gsap.to(button, {
          backgroundColor: theme.isLight() ? "black" : "white",
          justifyContent: button.style.justifyContent == 'flex-start' ? "flex-end" : "flex-start",
        });
        gsap.to(toggle, {
          backgroundColor: theme.isLight() ? "white" : "black",
        });
      });

      document.addEventListener("themeswitch", (e) => {
        gsap.to(title, {
          color: e.detail.color,
          duration: 0.6,
          ease: "linear",
        });
        if (window.innerWidth > 1024) {
          gsap.to(god_btn, {
            borderColor: e.detail.color,
            duration: 0.6,
            ease: "linear",
          });
          gsap.to(god_logo, {
            color: e.detail.color,
            duration: 0.6,
            ease: "linear",
            fill: e.detail.color,
          });
        }
      });
    },
  });
}
